<template>
  <div class="fulfillment-list-of-labels">
    <div v-if="loading" class="text-center py-3">
      <i class="fa fa-spinner fa-spin"></i>
      <div class="mt-1 small text-muted">Loading labels...</div>
    </div>
    <div v-else-if="labels && labels.length > 0" style="max-height: 340px; overflow-y: auto;">
      <div v-for="label in labels" :key="label.id" class="mb-2">
        <div
          class="card card-sm border mb-1"
          :class="{ 'opacity-50': label.isVoided || (label.shipment && label.shipment.status === 'Cancelled') }"
        >
          <div class="card-body py-2 px-3">
            <!-- Header: box / dimensions / status badge -->
            <div class="d-flex justify-content-between align-items-center mb-1">
              <div class="d-flex align-items-center flex-wrap">
                <span v-if="label.boxNumber" class="badge badge-info mr-2">Box {{ label.boxNumber }}</span>
                <span v-if="label.shipment && label.shipment.lengthIn" class="text-muted small">
                  {{ label.shipment.lengthIn }}" × {{ label.shipment.widthIn }}" × {{ label.shipment.heightIn }}"
                  <span v-if="label.shipment.weightLbs"> &mdash; {{ parseFloat(label.shipment.weightLbs).toFixed(3) }} lbs</span>
                </span>
              </div>
              <span :class="`badge badge-${shipmentStatusVariant(label.shipment && label.shipment.status)}`">
                {{ (label.shipment && label.shipment.status) || 'Unknown' }}
              </span>
            </div>
            <!-- Tracking / carrier / date + actions -->
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <div class="font-weight-bold small">{{ label.trackingNumber }}</div>
                <div class="text-muted small">{{ label.carrierName || label.carrier }} &mdash; {{ label.serviceName || label.service }}</div>
                <div class="text-muted small" v-if="label.shipDate">{{ new Date(label.shipDate).toLocaleDateString() }}</div>
              </div>
              <div class="d-flex" style="gap: 4px; flex-shrink: 0;">
                <b-button
                  class="btn-sml"
                  variant="outline-primary"
                  @click="$emit('download', label)"
                  :disabled="!label.id || label.isVoided"
                  title="Download label"
                >
                  <i class="fa fa-download"></i>
                </b-button>
                <b-button
                  class="btn-sml"
                  variant="outline-danger"
                  @click="$emit('void', label)"
                  :disabled="!label.id || label.isVoided"
                  title="Void label"
                >
                  <i class="fa fa-ban"></i>
                </b-button>
              </div>
            </div>
            <!-- Footer: items badge -->
            <div class="mt-1" v-if="label.shipment && label.shipment.items && label.shipment.items.length">
              <span
                class="badge badge-secondary"
                style="cursor: default;"
                v-b-popover.hover.top.html="buildItemsPopover(label.shipment.items)"
                title="Items"
              >
                {{ label.shipment.items.length }} item{{ label.shipment.items.length !== 1 ? 's' : '' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-center py-1 text-muted">
      <i class="fa fa-tag fa-2x mb-2 text-muted"></i>
      <div>No labels generated yet</div>
      <div class="small">Generate labels to see them here</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderShipmentLabelsList',
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    shipmentStatusVariant(status) {
      const map = {
        PendingConfirmation: 'warning',
        Created: 'info',
        InTransit: 'primary',
        Delivered: 'success',
        Cancelled: 'danger',
        Returned: 'secondary'
      };
      return map[status] || 'secondary';
    },
    buildItemsPopover(items) {
      if (!items || !items.length) return '';
      return '<ul class="mb-0 pl-3">' + items.map(i => `<li><strong>${i.quantity}×</strong> ${i.sku} &mdash; ${i.name || ''}</li>`).join('') + '</ul>';
    }
  }
};
</script>
